<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Buitenlandse belasting
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Land</b><br/>
                Kies het land waar deze belegging was ondergebracht. Verstrekt de bank geen jaaroverzicht met daarop een
                specificatie per land? Kijk dan op de afschriften of je die informatie daar wel kunt vinden.
                <div class="space10"></div>
                <b>Dividend e.d.</b><br/>
                Vul in: het bruto-dividend e.d. waarover de buitenlandse bronbelasting is ingehouden.
                <div class="space10"></div>
                <b>Buitenlandse belasting</b><br/>
                Vul in: de verrekenbare buitenlandse belasting die in het aangiftejaar is ingehouden over het dividend uit deze
                belegging. De verrekenbare buitenlandse belasting dient berekend te worden aan de hand van het bruto dividend
                vermenigvuldigd met het percentage dat in het belastingverdrag is afgesproken.

                Als het bronland méér belasting inhoudt dan het verdrag toestaat (bijv. 25% i.p.v. 15%), mag Nederland alleen
                het verdragstarief verrekenen. Het meerdere moet je zelf terugvragen bij de buitenlandse belastingdienst.
            </div>
        </div>
    </div>

</div>



